import axios from 'axios'
import FileSaver from 'file-saver'
import { useApi } from './useApi'
import { useNotifications } from './useNotifications'

export const useFiles = (): {
    getFile: (url: string, fileType: string, fileName?: string) => Promise<void>
} => {
    const { useGet } = useApi()
    const { pushFail } = useNotifications()

    const getFile = async (url: string, fileType?: string, fileName?: string) => {
        try {
            const response = await useGet(
                url,
                {},
                {
                    responseType: 'blob',
                },
            )
            const _fileType_ = response.data.type ? response.data.type.split('/')[1] : fileType
            FileSaver.saveAs(new Blob([response.data]), `${fileName || 'file'}.${_fileType_}`)
        } catch (error) {
            if (error instanceof Error) {
                if (axios.isAxiosError(error)) {
                    const response = await error.response?.data.text()
                    const message = response ? JSON.parse(response) : { data: { error: '' } }
                    pushFail(
                        `Nie udało się pobrać pliku. ${message.data ? message.data.error : ''}`,
                    )
                } else {
                    pushFail('Nie udało się pobrać pliku.')
                }
            }
        }
    }

    return {
        getFile,
    }
}
